<template>
  <!-- JetonPay 帳號 -->
  <div class="colu colu-12" :class="isPC ? 'fun-withdraw-jeton' : ''">
    <label class="colu-12 for-label">{{ $t('Bao.jeton_account') }}</label>
    <div :class="isPC ? 'wallet-amount-frame' : ''">
      <input
        :value="withdrawalInfo.uid"
        class="for-input inpType"
        type="text"
        :placeholder="$t('Bao.jeton_account')"
        autocomplete="off"
        @input="onInput($event.target.value)"
        @blur="$emit('check-jeton-errors')"
      >
    </div>
    <div
      v-for="error in jetonErrors"
      :key="error"
      class="input-feedback text-align-R"
    >
      {{ error }}
    </div>
  </div>
</template>

<script>
import { detectMob } from '@/utils/tool'

export default {
  name: 'PaymentUseJeton',
  inject: {
    errors: { default: () => ({ has: () => false }) }
  },
  props: {
    withdrawalInfo: {
      type: Object,
      default: () => ({})
    },
    jetonErrors: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {

    }
  },
  computed: {
    isPC() {
      return !detectMob()
    }
  },
  methods: {
    onInput(value) {
      this.$emit('update:withdrawal-info', { ...this.withdrawalInfo, uid: value })
      this.$emit('check-jeton-errors')
    }
  }
}
</script>
